export function roundRating(value: number): number {
  const intPart = Math.floor(value);
  const fracPercent = Math.round((value - intPart) * 100);

  if (fracPercent >= 10 && fracPercent <= 20) return intPart;
  if (fracPercent >= 30 && fracPercent <= 40) return intPart + 0.6;
  if (fracPercent > 40 && fracPercent <= 70) return value;
  if (fracPercent >= 80 && fracPercent <= 90) return intPart + 1;

  return Math.round(value);
}
